import axios from 'axios';
const instance = axios.create({

    baseURL: import.meta.env.VITE_BAS_URL, 
    strict: true,
        headers: {
            "X-CSRF": "1",
        },
 
})

export default instance